<template>
  <div class="qianyan-item-container">
    <custom-router-link :item="info" class="qianyan-item-link" :to="{name: 'QianyanDetails', params: {id: info.id}}" target="_blank">
      <div class="qianyan-item-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img2.png')" fit="cover" v-else></el-image>
      </div>
      <div class="qianyan-item-details">
        <div class="qianyan-item-title">{{info.name}}</div>
        <!-- <div class="qianyan-item-summary">{{info.summary}}</div> -->
        <div class="qianyan-item-more">
          <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
          <div class="more-info">
            <span>了解更多&nbsp;<i class="el-icon-right"></i></span>
          </div>
        </div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.qianyan-item-container {
  width: 100%;
  .qianyan-item-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.02);
    .qianyan-item-image {
      width: 100%;
      height: 134px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .qianyan-item-details {
      width: 100%;
      padding: 14px;
      .qianyan-item-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        height: 56px;
        margin-bottom: 10px;
        color: #212529;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .qianyan-item-summary {
        width: 100%;
        font-size: 15px;
        height: 40px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .publish-time {
      font-size: 14px;
      line-height: 22px;
      color: #6c757d;
      margin-top: 10px;
    }
    .qianyan-item-more {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #6c757d;
    }
    .more-info {
      display: flex;
      font-size: 16px;
      color: #212529;
      line-height: 32px;
      span {
        border-bottom: 2px solid #2960a7;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .qianyan-item-container {
    .qianyan-item-link {
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
      .qianyan-item-image {
        width: 100%;
        height: auto;
        aspect-ratio: 2;
        overflow: hidden;
      }
      .qianyan-item-details {
        width: 100%;
        padding: 14px;
        .qianyan-item-title {
          font-size: 18px;
          line-height: 24px;
          height: 48px;
          margin-bottom: 6px;
        }
        .qianyan-item-summary {
          font-size: 14px;
        }
      }
      .publish-time {
        font-size: 12px;
        line-height: 22px;
        color: #6c757d;
      }
      .qianyan-item-more {
        padding: 0;
      }
      .more-info {
        display: flex;
        font-size: 12px;
        color: #212529;
        line-height: 24px;
        span {
          border-bottom: 1px solid #2960a7;
          font-weight: 600;
        }
      }
    }
  }
}
</style>